var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_172_5015)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3329 12C21.3327 11.4483 21.2825 10.8977 21.1829 10.355L24.2259 8.6L21.2259 3.4L18.1819 5.159C17.3415 4.43993 16.3757 3.88194 15.3329 3.513V0H9.33294V3.513C8.2902 3.88194 7.32439 4.43993 6.48394 5.159L3.43994 3.4L0.439941 8.6L3.48294 10.355C3.28305 11.4426 3.28305 12.5574 3.48294 13.645L0.439941 15.4L3.43994 20.6L6.48394 18.842C7.32447 19.5607 8.29027 20.1184 9.33294 20.487V24H15.3329V20.487C16.3757 20.1181 17.3415 19.5601 18.1819 18.841L21.2259 20.6L24.2259 15.4L21.1829 13.645C21.2825 13.1023 21.3327 12.5517 21.3329 12ZM15.3329 12C15.3329 12.5933 15.157 13.1734 14.8273 13.6667C14.4977 14.1601 14.0292 14.5446 13.481 14.7716C12.9328 14.9987 12.3296 15.0581 11.7477 14.9424C11.1657 14.8266 10.6312 14.5409 10.2116 14.1213C9.79206 13.7018 9.50634 13.1672 9.39058 12.5853C9.27483 12.0033 9.33424 11.4001 9.5613 10.8519C9.78837 10.3038 10.1729 9.83524 10.6662 9.50559C11.1596 9.17595 11.7396 9 12.3329 9C13.1286 9 13.8917 9.31607 14.4543 9.87868C15.0169 10.4413 15.3329 11.2044 15.3329 12Z",
    fill: "#212538"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_172_5015"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.333008)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGear);
export default __webpack_public_path__ + "static/media/gear.a220619d33a24ddc8439369011e93406.svg";
export { ForwardRef as ReactComponent };